<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h4>Device Details</h4>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col>
            <p><b>Device Name:</b> {{ newDevice.deviceInfo.name }}</p>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <h4>Device Model Information</h4>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col>
            <p>
              <b>Manufacturer:</b> {{ newDevice.deviceInfo.deviceManufacturer }}
            </p>
            <p><b>Model:</b> {{ newDevice.deviceInfo.deviceModelName }}</p>
            <p>
              <b>Model Number:</b> {{ newDevice.deviceInfo.deviceModelNumber }}
            </p>

            <b-table
              :items="newDevice.deviceInfo.sensors"
              :fields="sensorFields"
              responsive
              hover
            />
          </b-col>
          <b-col
            class="d-flex justify-content-center"
          >
            <b-img
              :src="newDevice.deviceInfo.imgLink"
              alt="Device Model Image"
              height="400"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <h4>Network Information</h4>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col>
            <p v-if="network && network.networkType">
              <b>Network:</b> {{ network.networkType.name }}
            </p>
            <p v-if="network && network.networkOrgName">
              <b>Network Organization:</b> {{ network.networkOrgName }}
            </p>
            <p v-if="network && network.appId">
              <b>App ID:</b> {{ network.appId }}
            </p>

            <p
              v-if="newDevice && newDevice.network && newDevice.network.appEUI"
            >
              <b>App EUI:</b> {{ newDevice.network.appEUI }}
            </p>
            <p
              v-if="newDevice && newDevice.network && newDevice.network.devEUI"
            >
              <b>Dev EUI:</b> {{ newDevice.network.devEUI }}
            </p>
            <p
              v-if="newDevice && newDevice.network && newDevice.network.appKey"
            >
              <b>App Key:</b> {{ newDevice.network.appKey }}
            </p>
            <p
              v-if="newDevice && newDevice.network && newDevice.network.deviceProfileId"
            >
              <b>Device Profile ID:</b> {{ newDevice.network.deviceProfileId }}
            </p>
            <p
              v-if="newDevice && newDevice.network && newDevice.network.applicationId"
            >
              <b>Application ID:</b> {{ newDevice.network.applicationId }}
            </p>

          </b-col>
          <b-col
            v-if="network && network.networkType.logoLink"
            class="d-flex justify-content-center"
          >
            <b-img
              :src="network.networkType.logoLink"
              alt="Network Logo"
              height="200"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardHeader,
  BCardBody,
  BImg,
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,

    BCardHeader,
    BCardBody,
    BTable,
  },
  props: {
    newDevice: {
      type: Object,
      required: true,
    },
    network: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sensorFields: [
        { key: 'name', label: 'Sensor Name', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
      ],
    }
  },
}
</script>
<style scoped></style>
